/**
 * @desc 根据渠道单号查渠道退件
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.logisticsReturnRecordFacadeImpl.getLogisticsReverseLabel.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/getLogisticsReverseLabel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
